import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import React from 'react';
import clsx from 'clsx';
import HotFilterOptionItem from '@components/organisms/hot-filters/hot-filter-option-item/hot-filter-option-item';
import { useTranslation } from 'next-i18next';
import styles from './menu-item.module.scss';

interface MenuItemProps {
  handleClick: () => void;
  label: string;
  hasChildren: boolean;
  isSelected?: boolean;
  isHighlighted?: boolean;
  isDisabled: boolean;
  dataCySelector: string;
  htmlId?: string;
}

const MenuItem: React.FC<MenuItemProps> = ({
  handleClick,
  label,
  hasChildren,
  isHighlighted,
  isSelected,
  isDisabled,
  dataCySelector,
  htmlId,
}) => {
  const { t: tA11y } = useTranslation('a11y');
  return (
    <div className={clsx(styles.menuItem, (isHighlighted || isSelected) && styles.menuItem__highlighted)}>
      {hasChildren ? (
        <Button
          role="button"
          disableDefaultStyling={true}
          onClick={handleClick}
          className={styles.menuItem__button}
          data-cy={dataCySelector}
          id={htmlId}
          aria-haspopup="true"
          disabled={isDisabled}
          aria-disabled={isDisabled}
        >
          {label}
          <Icon
            name="ios-arrow-right-16"
            className={styles.menuItem__icon}
            aria-label={tA11y('A11Y.ICON.ARROW_RIGHT_CATEGORIES')}
          />
        </Button>
      ) : (
        <HotFilterOptionItem
          dataCy={dataCySelector}
          disabled={isSelected && isDisabled}
          checked={isSelected}
          label={label}
          htmlId={htmlId ?? `menu-item-${dataCySelector}`}
          onChange={handleClick}
          customLabelClass={styles.menuItem__input}
          containerClassName={styles.menuItem__container}
          identifier={`${dataCySelector}-list-item`}
        />
      )}
    </div>
  );
};

export default MenuItem;
